import Plyr from "plyr";

const initVideo = () => {
    const videos = document.querySelectorAll('.js-video');

    const players = [...videos].map( player => new Plyr(player));
}

export default initVideo;